import { useAtom, useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { SteppedPicker } from '../../../../components/SteppedPicker/SteppedPicker';
import { dateToPlainDateString } from '../../../../util/date-utilts';
import { FMT } from '../../../../util/formatter-service';
import { IRoundEntry, ownershipTimelineAsOfDateJ, roundsForCompanySyncJ, selectedRoundJ } from './state';

interface IAsOfDatePickerProps {
  companyId: number;
}

export function AsOfDatePicker({ companyId }: IAsOfDatePickerProps) {
  const rounds = useAtomValue(roundsForCompanySyncJ(companyId));
  const selected = useAtomValue(selectedRoundJ(companyId));
  const [, setAsOfDate] = useAtom(ownershipTimelineAsOfDateJ(companyId));

  const descendingRounds = useMemo(() => [...rounds].reverse(), [rounds]);

  const onSelect = useCallback(
    (entry: IRoundEntry) => {
      setAsOfDate(entry.isCurrent ? null : entry.date);
    },
    [setAsOfDate]
  );

  return (
    <SteppedPicker<IRoundEntry>
      items={descendingRounds}
      selectedKey={selected?.key ?? null}
      onSelect={onSelect}
      renderLabel={formatRoundLabel}
      label='As of Date:'
      ariaLabel='as of date'
      prevAriaLabel='previous round'
      nextAriaLabel='next round'
      cycleDirection='backward'
    />
  );
}

function formatRoundLabel(entry: IRoundEntry | null): string {
  if (!entry) {
    return 'Select a date';
  }
  const dateStr = FMT.format('dateNumeric', dateToPlainDateString(entry.date));
  return entry.isCurrent ? `Current — ${dateStr}` : dateStr;
}
